import { render, staticRenderFns } from "./CompleteAccountModal.vue?vue&type=template&id=31f7c7c1&scoped=true&"
import script from "./CompleteAccountModal.vue?vue&type=script&lang=js&"
export * from "./CompleteAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./CompleteAccountModal.vue?vue&type=style&index=0&id=31f7c7c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f7c7c1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/app/components/Footer.vue').default})
